/** Update cards Julian opened this session. Cards start closed so a long run never pushes
 *  the reply out of view; one he opened stays open when the live card is replaced. */
export const openedCards = new Set<string>();

/** The empty first frame became a real segment: the choice Julian made on it moves along. */
export function carryOpenCard(from: string, to: string) {
  if (openedCards.delete(from)) openedCards.add(to);
}
